@if (isAdmin) {
<div>
  <app-admin-home></app-admin-home>
</div>
} @if (isContrator) {
<div>
  <app-contractor-home></app-contractor-home>
</div>
} @if (isGrower) {
<div>
  <app-grower-home></app-grower-home>
</div>
}
